'use client';

import { isEmpty } from '@cat-ecom/common/utils/commonUtils';
import { PurifiedHtml } from 'components/purified-html';
import { useEspotEvent } from 'hooks/analytics/use-espot-event';
import { useEffect } from 'react';
import { espotContentProps } from 'services/marketing/types';

export const EspotContent = ({
  content,
  className,
  id,
  allowScript,
  skipSanitize,
  analyticsData
}: espotContentProps) => {
  const { html } = content;
  const { fireEvent } = useEspotEvent();
  const triggerAnalytics = analyticsData
    ? analyticsData?.triggerAnalytics
    : false;

  useEffect(() => {
    if (!isEmpty(analyticsData) && triggerAnalytics) {
      fireEvent(analyticsData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (skipSanitize) {
    return (
      <div
        className={className}
        id={id}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    );
  }

  return (
    <PurifiedHtml
      htmlString={html}
      className={className}
      id={id}
      forceBody
      allowScript={allowScript}
    />
  );
};
